import { HttpClient } from '@angular/common/http';
import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore } from '@angular/fire/firestore';
import { MatPaginator, MatDialog, PageEvent, Sort, MatDialogConfig } from '@angular/material';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { DateFormatService } from 'src/app/Services/Utilities/date-format.service';
import { ExcelHelperService } from 'src/app/Services/Utilities/excel-helper.service';
import { ExhibService } from 'src/app/Services/Utilities/exhib.service';
import { UserInfoService } from 'src/app/Services/Utilities/user-info.service';
import { ConfirmationDialogComponent } from 'src/app/Shared/confirmation-dialog/confirmation-dialog.component';
import { RemarkComponent } from 'src/app/Shared/remark/remark.component';
import { SelectionComponent } from '../../cic/selection/selection.component';
import { SubmitFormComponent } from '../../cic/submit-form/submit-form.component';
import { ModifyComponent } from '../../exhibition/modify/modify.component';
import { ProfilePopComponent } from '../../exhibition/profile-pop/profile-pop.component';

@Component({
  selector: 'app-visitor-board',
  templateUrl: './visitor-board.component.html',
  styleUrls: ['./visitor-board.component.scss']
})
export class VisitorBoardComponent implements OnInit {

    hidePassword = true;
    hidePasswordR = true;
    hideConfirmPasswordR = true;
  
    private dateFormat = new DateFormatService();
  
    registerModel = null;
  
    flag = true;
    validationsMessages = ' ';
    today = Date.now();
    breakpoint: boolean;
    app;
  
    filelist = [];
    sortedfilelist = [];
    length = 0;
    pageSize = 10000;
    pageSizeOptions: number[] = [10, 25, 50];
    pageIndex = 0;
    offset = this.pageSize * this.pageIndex;
    searchbox = '';
    searchValue = '';
    sortedu = {
      active: '',
      direction: ''
    };
    dateRange: any;
    email: any;
    uuid: any;
    loading = true;
  
    @ViewChild('topPaginator', { read: MatPaginator, static: false }) topPaginator: MatPaginator;
    @ViewChild('bottomPaginator', { read: MatPaginator, static: false }) bottomPaginator: MatPaginator;
    role: string[];
  
    disableEdit: boolean = false;
  
    constructor(
      private router: Router,
      private toast: ToastrService,
      private angularFireAuth: AngularFireAuth,
      private dialog: MatDialog,
      private spinner: NgxSpinnerService,
      private userinfoSrv: UserInfoService,
      private firestore: AngularFirestore,
      private toaster: ToastrService,
      private http: HttpClient,
      public exhibSrv: ExhibService,
      private excelHelper: ExcelHelperService
    ) {
    }
 
    SetupFile() {
      this.spinner.show();
      this.pageSize = 10;
      this.offset = this.pageSize * this.pageIndex;
      this.searchbox = '';
      this.searchValue = '';
      this.sortedu = {
        active: '',
        direction: ''
      };
      this.loading = true;
  
      this.filelist = [];
      this.sortedfilelist = [];
        this.firestore.collection('VisitorRegister', ref => ref.orderBy('visitorDate', 'desc')).get().forEach(e => {
          e.forEach(file => {
            const data : any= {
              ...file.data(),
              id: file.id,
              visitorDate: new Date(file.data().visitorDate.toDate()),
            }
  
            this.filelist.push(data);
            this.sortedfilelist = this.filelist.slice(this.offset, (this.offset + this.pageSize));
            this.loading = false;
            this.length = this.filelist.length;
          })
          this.spinner.hide();
          this.loading = false;
        });
    }
  
    ngOnInit() {
      this.angularFireAuth.authState.subscribe(async authState => {
        this.spinner.show()
        if (authState === null) {
          this.spinner.hide();
        } else {
          this.email = this.email;
          await this.firestore.collection("Admin").doc(authState.uid).get().forEach(async e => {
            if (e.exists) {
              const role = []
              role.push(e.data().Role);

              if(e.data().Role === 'SuperAdmin'){
                this.SetupFile();
              }else{
                this.router.navigate([''])
              }
            }
            else {
              this.router.navigate([''])
            }
          });
          this.spinner.hide();
        }
      })
    }
  
    @HostListener('window:resize', ['$event'])
    onResize(event) {
  
      this.breakpoint = (window.innerWidth <= 800) ? true : false;
    }
  
  
    goProfile() {
      this.router.navigate(['profile'])
    }
    goExhibition() {
      this.router.navigate(['innovation'])
    }
  
    view(file, type = "view") {
      if (type === 'view') {
        this.exhibSrv.setExhib(file);
        this.exhibSrv.setType(type);
        this.router.navigate(['/innovation/view'])
  
      }
      else if (type === 'mark') {
        this.exhibSrv.setExhib(file);
        this.exhibSrv.setType(type);
        this.router.navigate(['/innovation/view'])
      }
      else if (type === 'disabled') {
        this.exhibSrv.setExhib(file);
        this.exhibSrv.setType(type);
        this.router.navigate(['/innovation/view'])
      }
    }
  
  
    paginator(pageEvent: PageEvent) {
      this.pageSize = pageEvent.pageSize;
      this.pageIndex = pageEvent.pageIndex;
      this.offset = this.pageSize * this.pageIndex;
      if (this.topPaginator.pageIndex < this.pageIndex) {
        this.topPaginator.nextPage();
      } else if (this.topPaginator.pageIndex > this.pageIndex) {
        this.topPaginator.previousPage();
      }
      if (this.bottomPaginator.pageIndex < this.pageIndex) {
        this.bottomPaginator.nextPage();
      } else if (this.bottomPaginator.pageIndex > this.pageIndex) {
        this.bottomPaginator.previousPage();
      }
      this.sortedfilelist = this.filelist.slice();
      this.sortFile();
      this.limitFile();
    }
  
    limitFile() {
      this.sortedfilelist = this.sortedfilelist.slice(this.offset, (this.offset + this.pageSize));
    }
  
    sortData(sort: Sort) {
      this.sortedu = sort;
      this.sortedfilelist = this.filelist.slice();
      if (this.status || this.fileName || this.dateRange) {
        this.DS();
      }
      if (!sort.active || sort.direction === '' && !(this.status || this.fileName || this.dateRange)) {
        this.sortedfilelist = this.filelist.slice();
        this.limitFile();
        return;
      }
  
      this.sortedfilelist = this.sortedfilelist.sort((a, b) => {
        const isAsc = this.sortedu.direction === 'asc';
        switch (this.sortedu.active) {
          case 'name': return this.compare(a.name, b.name, isAsc);
          case 'company': return this.compare(a.company, b.company, isAsc);
          case 'phone': return this.compare(a.phone, b.phone, isAsc);
          case 'email': return this.compare(a.email, b.email, isAsc);
          case 'agreeTnc': return this.compare(a.agreeTnc, b.agreeTnc, isAsc);
          case 'visitorDate': return this.compareDate(a.visitorDate, b.visitorDate, isAsc);
          default: return 0;
        }
      });
      this.limitFile();
    }
  
    sortFile() {
      if (!this.sortedu.active || this.sortedu.direction === '') {
        return;
      }
      this.sortedfilelist = this.sortedfilelist.sort((a, b) => {
        const isAsc = this.sortedu.direction === 'asc';
        switch (this.sortedu.active) {
          case 'name': return this.compare(a.name, b.name, isAsc);
          case 'company': return this.compare(a.company, b.company, isAsc);
          case 'phone': return this.compare(a.phone, b.phone, isAsc);
          case 'email': return this.compare(a.email, b.email, isAsc);
          case 'agreeTnc': return this.compare(a.agreeTnc, b.agreeTnc, isAsc);
          case 'visitorDate': return this.compareDate(a.visitorDate, b.visitorDate, isAsc);
          default: return 0;
        }
      });
    }
  
    compare(a: number | string, b: number | string, isAsc: boolean) {
      return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
    }
  
    reset() {
      this.fileName = '';
      this.status = 'All';
      this.dateRange = '';
      this.SetupFile();
    }
    search() {
      this.sortedfilelist = this.filelist.filter(u =>
        String(u.name).toLowerCase().includes(this.searchbox.toLowerCase()) ||
        String(u.company).toLowerCase().includes(this.searchbox.toLowerCase()) ||
        String(u.phone).toLowerCase().includes(this.searchbox.toLowerCase()) ||
        String(u.email).toLowerCase().includes(this.searchbox.toLowerCase()) ||
        String(u.agreeTnc).toLowerCase().includes(this.searchbox.toLowerCase()) ||
        String(u.heardUs).toLowerCase().includes(this.searchbox.toLowerCase())
      );
  
      this.length = this.sortedfilelist.length;
      this.sortFile();
      this.limitFile();
    }
  
    DS() {
  
      this.sortedfilelist = this.filelist.filter(u =>
        String(u.name).toLowerCase().includes(this.searchbox.toLowerCase()) ||
        String(u.company).toLowerCase().includes(this.searchbox.toLowerCase()) ||
        String(u.phone).toLowerCase().includes(this.searchbox.toLowerCase()) ||
        String(u.email).toLowerCase().includes(this.searchbox.toLowerCase()) ||
        String(u.agreeTnc).toLowerCase().includes(this.searchbox.toLowerCase()) ||
        String(u.heardUs).toLowerCase().includes(this.searchbox.toLowerCase())
      );
  
      this.length = this.sortedfilelist.length;
      this.sortFile();
    }
  
    status = "All"
    fileName = '';
    applicationList = [];
    SelectStatus(status) {
      this.status = status;
    }
  
    dateRangeChange(e) {
  
    }
  
    compareDate(a, b, isAsc: boolean) {
      a = new Date(a);
      b = new Date(b);
      return (a > b ? -1 : a < b ? 1 : 0) * (isAsc ? -1 : 1);
    }
  
    add() {
      if(this.registerModel != null){
        this.router.navigate(['/innovation/add'])
      }else{
        this.toast.warning("Non-user detected, please complete the pop up to fill in profile info")
        this.dialog.open(ProfilePopComponent, {
          width: '70%',
          height: '80%',
          disableClose: true,
          position: {
            'top':'10%'
          }
        }).afterClosed().subscribe(r => {
          if(r){
            this.SetupFile()
          }
        });
      }
    }
  
    SubmitForm(file) {
      this.dialog.open(SubmitFormComponent, {
        width: '70%',
        height: '80%',
        disableClose: true,
        data: file.id
      }).afterClosed().subscribe(r => {
        this.SetupFile();
      });
    }
  
    edit(file) {
      this.exhibSrv.setExhib(file);
      this.router.navigate(['/innovation/edit'])
  
    }
  
    cancel(file) {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.autoFocus = false;
      dialogConfig.height = 'auto';
      dialogConfig.width = 'auto';
  
      const position = { top: '15%' };
      dialogConfig.position = position;
      dialogConfig.disableClose = true;
      dialogConfig.data = 'Confirm want to cancel this application';
  
      this.dialog.open(ConfirmationDialogComponent, dialogConfig).afterClosed().subscribe(async data => {
        if (data) {
          try {
            this.spinner.show();
            await this.firestore.collection("Exhib").doc(file.id).update({ Status: "Canceled", UpdatedDate: new Date(), UpdatedBy: this.email });
            file.Status = "Canceled";
  
            const dateFormat = this.dateFormat.convertDateIntoYearMonthDay(new Date());
            const info = {
              message: "Application " + file.id + " has been canceled by Email: " + this.email,
              date: new Date()
            };
            await this.firestore.collection('ExhibLog').doc(dateFormat).set({ Date: new Date() });
            await this.firestore.collection('ExhibLog').doc(dateFormat).collection('User').add(info);
  
  
            this.spinner.hide();
            this.toaster.success("Cancel Successfully");
          } catch (error) {
            this.toaster.error(error, "Error happen");
            this.spinner.hide();
  
          }
        }
      })
    }
  
    delete(file) {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.autoFocus = false;
      dialogConfig.height = 'auto';
      dialogConfig.width = 'auto';
  
      const position = { top: '15%' };
      dialogConfig.position = position;
      dialogConfig.disableClose = true;
      dialogConfig.data = 'Confirm want to delete this application';
  
      this.dialog.open(ConfirmationDialogComponent, dialogConfig).afterClosed().subscribe(async data => {
        if (data) {
          try {
            this.spinner.show();
            await this.firestore.collection("Exhib").doc(file.id).delete();
            let index = this.filelist.findIndex(e=>e.id === file.id);
            this.filelist.splice(index,1)
            
            this.sortedfilelist = this.filelist.slice();
            this.sortFile();
            this.limitFile();
  
            const dateFormat = this.dateFormat.convertDateIntoYearMonthDay(new Date());
            const info = {
              message: "Application " + file.id + " has been deleted by Email: " + this.email,
              date: new Date()
            };
            await this.firestore.collection('ExhibLog').doc(dateFormat).set({ Date: new Date() });
            await this.firestore.collection('ExhibLog').doc(dateFormat).collection('Admin').add(info);
            this.spinner.hide();
            this.toaster.success("Deleted Successfully");
          } catch (error) {
            this.toaster.error(error, "Error happen");
            this.spinner.hide();
  
          }
        }
      })
    }
  
    reject(file) {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.autoFocus = false;
      dialogConfig.height = 'auto';
      dialogConfig.width = 'auto';
  
      const position = { top: '15%' };
      dialogConfig.position = position;
      dialogConfig.disableClose = true;
      dialogConfig.data = 'Confirm want to reject this application';
  
      this.dialog.open(ConfirmationDialogComponent, dialogConfig).afterClosed().subscribe(async data => {
        if (data) {
          try {
            this.spinner.show();
            await this.firestore.collection("Exhib").doc(file.id).update({ Status: "Rejected", UpdatedDate: new Date(), UpdatedBy: this.email });
            file.Status = "Rejected";
  
            const dateFormat = this.dateFormat.convertDateIntoYearMonthDay(new Date());
            const info = {
              message: "Application " + file.id + " has been rejected by Email: " + this.email,
              date: new Date()
            };
            await this.firestore.collection('ExhibLog').doc(dateFormat).set({ Date: new Date() });
            await this.firestore.collection('ExhibLog').doc(dateFormat).collection('Admin').add(info);
            this.spinner.hide();
            this.toaster.success("Reject Successfully");
          } catch (error) {
            this.toaster.error(error, "Error happen");
            this.spinner.hide();
  
          }
        }
      })
    }
  
    complete(file) {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.autoFocus = false;
      dialogConfig.height = 'auto';
      dialogConfig.width = 'auto';
  
      const position = { top: '15%' };
      dialogConfig.position = position;
      dialogConfig.disableClose = true;
      dialogConfig.data = 'Confirm want to complete this application';
  
      this.dialog.open(ConfirmationDialogComponent, dialogConfig).afterClosed().subscribe(async data => {
        if (data) {
          try {
            this.spinner.show();
            await this.firestore.collection("Exhib").doc(file.id).update({ Status: "Completed", UpdatedDate: new Date(), UpdatedBy: this.email });
            file.Status = "Completed";
  
            const dateFormat = this.dateFormat.convertDateIntoYearMonthDay(new Date());
            const info = {
              message: "Application " + file.id + " has been completed by Email: " + this.email,
              date: new Date()
            };
            await this.firestore.collection('ExhibLog').doc(dateFormat).set({ Date: new Date() });
            await this.firestore.collection('ExhibLog').doc(dateFormat).collection('Admin').add(info);
            this.spinner.hide();
            this.toaster.success("Completed Successfully");
          } catch (error) {
            this.toaster.error(error, "Error happen");
            this.spinner.hide();
  
          }
        }
      })
    }
  
    assign(file) {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.autoFocus = false;
      dialogConfig.height = 'auto';
      dialogConfig.width = '50%';
  
      const position = { top: '15%' };
      dialogConfig.position = position;
      dialogConfig.disableClose = true;
      dialogConfig.data = file;
  
      this.dialog.open(SelectionComponent, dialogConfig).afterClosed().subscribe(async data => {
        if (data) {
          try {
            this.spinner.show();
            let assignList = [];
            if (data.length > 0) {
              for (const d of data) {
                if (d.userAcc && d.userId) {
                  assignList.push(d.email);
                  file.Assigned = assignList;
  
                  this.firestore.collection('Admin').doc(d.userId).set({ Email: d.userAcc, Role: 'Admin' })
                  this.firestore.collection("Exhib").doc(file.id).update({ Status: "Assigned", Assigned: assignList, UpdatedDate: new Date(), UpdatedBy: this.email });
                }
                else if (d.needCreate) {
                  const body = {
                    email: d.email
                  }
                  this.http.post(`https://inno-api-c3sd2zaqha-as.a.run.app/assessorRegister`, body).subscribe((result: any) => {
                    assignList.push(d.email);
                    file.Assigned = assignList;
  
                    if (result.id) {
                      this.firestore.collection('Admin').doc(result.id).set({ Email: d.email, Role: 'Admin' })
                      this.firestore.collection("Exhib").doc(file.id).update({ Status: "Assigned", Assigned: assignList, UpdatedDate: new Date(), UpdatedBy: this.email });
                    }
                  }, error => {
                    console.log(error)
                    this.toast.error("Failed to create assesor acc for " + d.email)
                  })
                } else {
                  assignList.push(d.email);
                  file.Assigned = assignList;
  
                  this.firestore.collection("Exhib").doc(file.id).update({ Status: "Assigned", Assigned: assignList, UpdatedDate: new Date(), UpdatedBy: this.email });
  
                }
              }
            }
  
            const body ={
              name: file.id,
              emails: assignList
            }
            this.http.post(`https://ino-email-c3sd2zaqha-as.a.run.app/notify`, body).subscribe((result: any) => {
            }, error => {
              console.log(error)
              // this.toast.error("Failed to notify email " + email)
            })
          
            file.Status = "Assigned";
            file.assign = data.id;
  
            const dateFormat = this.dateFormat.convertDateIntoYearMonthDay(new Date());
            const info = {
              message: "Application " + file.id + " has been assigned by Email: " + this.email,
              date: new Date()
            };
            await this.firestore.collection('ExhibLog').doc(dateFormat).set({ Date: new Date() });
            await this.firestore.collection('ExhibLog').doc(dateFormat).collection('Admin').add(info);
            this.spinner.hide();
            this.toaster.success("Assign Successfully");
          } catch (error) {
            this.toaster.error(error, "Error happen");
            this.spinner.hide();
  
          }
        }
      })
    }
  
    remark(file) {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.autoFocus = false;
      dialogConfig.height = 'auto';
      const position = { top: '15%' };
      dialogConfig.position = position;
      dialogConfig.disableClose = true;
      dialogConfig.data = file.personalRemark || '';
  
      this.dialog.open(RemarkComponent, dialogConfig).afterClosed().subscribe(async data => {
        if (data) {
          try {
           
            const assesorRemark = {
              ...file.assesorRemark,
              [this.email]: data
            }
  
            file.personalRemark = data;
          
            await this.firestore.collection("Exhib").doc(file.id).update({assesorRemark: assesorRemark, UpdatedDate: new Date(), UpdatedBy: this.email });
  
  
            const dateFormat = this.dateFormat.convertDateIntoYearMonthDay(new Date());
            const info = {
              message: "Application " + file.id + " remark : " + data + " inserted by" + this.email,
              date: new Date()
            };
            await this.firestore.collection('ExhibLog').doc(dateFormat).set({ Date: new Date() });
            await this.firestore.collection('ExhibLog').doc(dateFormat).collection('Admin').add(info);
            this.spinner.hide();
            this.toaster.success("Insert remark Successfully");
          } catch (error) {
            this.toaster.error(error, "Error happen");
            this.spinner.hide();
  
          }
        }
      })
    }
  
    remarkA(file) {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.autoFocus = false;
      dialogConfig.height = 'auto';
      const position = { top: '15%' };
      dialogConfig.position = position;
      dialogConfig.disableClose = true;
      dialogConfig.data = file.adminRemark || '';
  
      this.dialog.open(RemarkComponent, dialogConfig).afterClosed().subscribe(async data => {
        if (data) {
          try {
           
            const adminRemark = data
            file.adminRemark = data;
            await this.firestore.collection("Exhib").doc(file.id).update({adminRemark: adminRemark, UpdatedDate: new Date(), UpdatedBy: this.email });
  
            const dateFormat = this.dateFormat.convertDateIntoYearMonthDay(new Date());
            const info = {
              message: "Application " + file.id + " remark : " + data + " inserted by" + this.email,
              date: new Date()
            };
            await this.firestore.collection('ExhibLog').doc(dateFormat).set({ Date: new Date() });
            await this.firestore.collection('ExhibLog').doc(dateFormat).collection('Admin').add(info);
            this.spinner.hide();
            this.toaster.success("Insert remark Successfully");
          } catch (error) {
            this.toaster.error(error, "Error happen");
            this.spinner.hide();
  
          }
        }
      })
    }
  
  
  
    remove(file) {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.autoFocus = false;
      dialogConfig.height = 'auto';
      dialogConfig.width = 'auto';
  
      const position = { top: '15%' };
      dialogConfig.position = position;
      dialogConfig.disableClose = true;
      dialogConfig.data = 'Confirm want to delete this application';
  
      this.dialog.open(ConfirmationDialogComponent, dialogConfig).afterClosed().subscribe(async data => {
        if (data) {
          try {
            this.spinner.show();
            await this.firestore.collection("Exhib").doc(file.id).delete().then(async e => {
              const dateFormat = this.dateFormat.convertDateIntoYearMonthDay(new Date());
              const info = {
                message: "Application " + file.id + " has been deleted by Email: " + this.email,
                date: new Date()
              };
              await this.firestore.collection('ExhibLog').doc(dateFormat).set({ Date: new Date() });
              await this.firestore.collection('ExhibLog').doc(dateFormat).collection('User').add(info);
  
              this.spinner.hide();
              this.toaster.success("Delete Successfully");
              this.SetupFile();
            });
          } catch (error) {
            this.toaster.error(error, "Error happen");
            this.spinner.hide();
  
          }
        }
      })
    }
  
    clone(file) {
      this.spinner.show();
  
      try {
        this.firestore.collection("ExhibID").doc("ID").get().forEach(async item => {
          let ID = ('000' + item.data().ID).slice(-3);
          ID = `EX${new Date().getFullYear()}-${ID}`;
          this.firestore.collection('Exhib').doc(file.id).get().forEach(async e => {
            if (e.exists) {
  
              let info = {
                ...e.data(),
                CreatedDate: new Date(),
                UpdatedDate: new Date(),
                Status: "Draft",
              }
              await this.firestore.collection("Exhib").doc(ID).set({ ...info, ReceiptNames: null, ReceiptUrls: null });
              const dateFormat = this.dateFormat.convertDateIntoYearMonthDay(new Date());
              const infos = {
                message: "Application" + file.id + " has been cloned to  " + ID + " by " + this.email,
                date: new Date(),
                data: JSON.stringify(info),
              };
              await this.firestore.collection('ExhibLog').doc(dateFormat).set({ Date: new Date() });
              await this.firestore.collection('ExhibLog').doc(dateFormat).collection('User').add(infos);
              await this.firestore.collection('ExhibID').doc("ID").set({ ID: item.data().ID + 1 })
  
              this.toaster.success("Clone successfully");
              this.SetupFile();
            }
            this.spinner.hide();
          });
        })
  
      } catch (error) {
        this.spinner.hide();
        this.toaster.error("Failed to clone");
  
      }
  
    }
  
  
    SubmitReceipt(file) {
      this.dialog.open(SubmitFormComponent, {
        width: '70%',
        height: '50%',
        disableClose: true,
        position: { top: '12%' },
        data: { file: file.id, type: 2, name: file.introFormGroup.Applicant, receipt: file }
      }).afterClosed().subscribe(r => {
        this.SetupFile();
      });
    }
  
    async download() {
      const url = 'https://firebasestorage.googleapis.com/v0/b/innozilla-1a662.appspot.com/o/Rubric.docx?alt=media&token=8c22391a-afbd-4196-99c3-5fc23bb87186'
      const existingPdfBytes = await fetch(url).then(res => res.arrayBuffer())
      let file = new Blob([existingPdfBytes], { type: 'application/vnd.openxmlformats-officedocument.presentationml.presentation' });
      var fileURL = URL.createObjectURL(file);
      var anchor = document.createElement("a");
      anchor.download = "Rubric.docx";
      anchor.href = fileURL;
      anchor.click();
    }
  
    getMark(marks) {
      return marks.reduce((a, b) => a + (b?parseFloat(b): 0), 0).toFixed(2)
    }
  
    getSMark(email, file) {
      let str = ''
      str = file.calculatedMark ? Object.keys(file.calculatedMark).includes(email) ? this.getMark(file.calculatedMark[email]) : '?' : '?';
      return str;
    }
  
    viewMark(email, file) {
  
      let mark = file.marks ? Object.keys(file.marks).includes(email) ? file.marks[email] : null : null;
      if (mark) {
        this.exhibSrv.setExhib(mark);
        let rubricType;
        switch(file.modeInfo.typeOfParticipant){
          case 'University/College Student': rubricType = 1; break;
          case 'Primary/Secondary School Student': rubricType = 2; break;
          case 'Professional/Industry': rubricType = 3; break;
        }
  
        this.exhibSrv.setRubric(rubricType);
        this.router.navigate(['/innovation/viewMark'])
      }
  
    }
  
    redirect() {
      window.open('https://upay.usm.my/innozilla', "_blank");
    }
  
    async download1() {
      const url = 'https://firebasestorage.googleapis.com/v0/b/innozilla-1a662.appspot.com/o/Rubric%20for%20invention%20evaluation%20-%20Professional%20-%20%20Industry%20(2).docx?alt=media&token=4c027c89-2cf4-45f7-8590-39e2e65e0ed4'
      const existingPdfBytes = await fetch(url).then(res => res.arrayBuffer())
      let file = new Blob([existingPdfBytes], { type: 'application/vnd.openxmlformats-officedocument.presentationml.presentation' });
      var fileURL = URL.createObjectURL(file);
      var anchor = document.createElement("a");
      anchor.download = "Rubric for invention evaluation - Professional -  Industry.docx";
      anchor.href = fileURL;
      anchor.click();
    }
    async download2() {
      const url = 'https://firebasestorage.googleapis.com/v0/b/innozilla-1a662.appspot.com/o/Rubric%20for%20invention%20evaluation%20-%20School%20Students%20(2).docx?alt=media&token=9cf91554-4f82-4733-bd06-feedbefc3fd4'
      const existingPdfBytes = await fetch(url).then(res => res.arrayBuffer())
      let file = new Blob([existingPdfBytes], { type: 'application/vnd.openxmlformats-officedocument.presentationml.presentation' });
      var fileURL = URL.createObjectURL(file);
      var anchor = document.createElement("a");
      anchor.download = "Rubric for invention evaluation - School Students.docx";
      anchor.href = fileURL;
      anchor.click();
    }
    async download3() {
      const url = 'https://firebasestorage.googleapis.com/v0/b/innozilla-1a662.appspot.com/o/Rubric%20for%20invention%20evaluation%20-%20Scoring%20Marks.docx?alt=media&token=4f21aa5b-5906-4240-84a5-0c4e5dadd1d1'
      const existingPdfBytes = await fetch(url).then(res => res.arrayBuffer())
      let file = new Blob([existingPdfBytes], { type: 'application/vnd.openxmlformats-officedocument.presentationml.presentation' });
      var fileURL = URL.createObjectURL(file);
      var anchor = document.createElement("a");
      anchor.download = "Rubric for invention evaluation - Scoring Marks.docx";
      anchor.href = fileURL;
      anchor.click();
    }
    async download4() {
      const url = 'https://firebasestorage.googleapis.com/v0/b/innozilla-1a662.appspot.com/o/Rubric%20for%20invention%20evaluation%20-%20University%20student%20(2).docx?alt=media&token=93d5dff6-e57b-4460-aa74-122a3b64efcb'
      const existingPdfBytes = await fetch(url).then(res => res.arrayBuffer())
      let file = new Blob([existingPdfBytes], { type: 'application/vnd.openxmlformats-officedocument.presentationml.presentation' });
      var fileURL = URL.createObjectURL(file);
      var anchor = document.createElement("a");
      anchor.download = "Rubric for invention evaluation - University student.docx";
      anchor.href = fileURL;
      anchor.click();
    }
  
    modify(file) {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.autoFocus = false;
      dialogConfig.height = 'auto';
      dialogConfig.width = '50%';
  
      const position = { top: '15%' };
      dialogConfig.position = position;
      dialogConfig.disableClose = true;
      dialogConfig.data = {...file.modeInfo, techCategory: file.techFormGroup.Category, mark: file.finalMark};
  
      this.dialog.open(ModifyComponent, dialogConfig).afterClosed().subscribe(async data => {
        if (data) {
          try {
            this.spinner.show();
            file.techFormGroup.Category = data.techCategory
            const update: any = { modeInfo: data, techFormGroup: file.techFormGroup, UpdatedDate: new Date(), UpdatedBy: this.email }
            if(data.mark){
              file.finalMark = parseFloat(data.mark);
              file.averageMark = parseFloat(data.mark);
              update.finalMark = parseFloat(data.mark);
            }
  
            this.firestore.collection("Exhib").doc(file.id).update(update);
            file.modeInfo = data;
  
            const dateFormat = this.dateFormat.convertDateIntoYearMonthDay(new Date());
            const info = {
              message: "Application " + file.id + " has been updated by Email: " + this.email,
              date: new Date(),
              data: data
            };
            await this.firestore.collection('ExhibLog').doc(dateFormat).set({ Date: new Date() });
            await this.firestore.collection('ExhibLog').doc(dateFormat).collection('Admin').add(info);
            this.spinner.hide();
            this.toaster.success("Modify Successfully");
          } catch (error) {
            this.toaster.error(error, "Error happen");
            this.spinner.hide();
  
          }
        }
      })
    }
  
    
    exportExcel() {
      const exportInformation = [];
  
      this.spinner.show();
  
      for (const p of this.filelist) {
        const info = {
          "ID": p.id,
          "Assessors": p.Assigned? p.Assigned.reduce((a,b)=> a? (a + ',' + b) : (a + '' + b), ''): '-',
          "Average Mark": p.averageMark.toFixed(2),
          "Category": p.techFormGroup.Category,
          "Participant Type": p.type1 || '-',
          "Innozilla Type": p.type2 || '-',
          "Participant Mode": p.modeInfo? p.modeInfo.mode: '-',
          "Participant Category": p.modeInfo? p.modeInfo.typeOfParticipant: '-',
          "USM Staff": p.modeInfo? p.modeInfo.usmStaff: '-',
          "Status": p.Status,
          "Remarks": p.assesorRemark? Object.values(p.assesorRemark).reduce((a,b)=> a? (a + ',' + b) : (a + '' + b), ''): '-',
          "Admin remark": p.adminRemark? p.adminRemark: '-',
        }
       
        exportInformation.push(info)
      }
    
      this.excelHelper.exportAsExcelFile(exportInformation, 'Innovation' + new Date().getTime());
  
      this.spinner.hide();
  
    }
  
  }